import React from 'react';
import './Chip.scss';

interface ChipProps {
  href: string;
  label: string;
  mobile?: boolean;
  dataEm: string;
}

const Chip: React.FC<ChipProps> = ({ label, href, mobile, dataEm }) => {
  return (
    <a
      href={href}
      className="trending-search-chip hmf-display-flex hmf-justify-content-center hmf-px-xxs hmf-px-md-xs hmf-text-decoration-none">
      <span
        className="hmf-body-m hmf-display-flex hmf-align-items-center"
        aria-label={label}
        data-em={dataEm}>
        {label}
      </span>
    </a>
  );
};

export default Chip;

Chip.defaultProps = {
  mobile: false,
};
